import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PageContainer from '../components/ui/PageContainer';

export default function Dashboard() {
  const navigate = useNavigate();
  const { role } = useAuth();

  useEffect(() => {
    // Redirect to role-specific dashboard
    if (role) {
      switch (role) {
        case 'RENTER':
          navigate('/renter/dashboard');
          break;
        case 'OWNER':
          navigate('/owner/dashboard');
          break;
        case 'AGENT':
          navigate('/agent/dashboard');
          break;
        case 'CONTRACTOR':
          navigate('/contractor/dashboard');
          break;
        case 'ADMIN':
          navigate('/admin/dashboard');
          break;
      }
    }
  }, [role, navigate]);

  return (
    <PageContainer>
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-2">Loading Dashboard...</h2>
          <p className="text-gray-600">Redirecting you to your dashboard</p>
        </div>
      </div>
    </PageContainer>
  );
}

